import { Transforms } from 'vendor/slate'
import { ReactEditor } from 'vendor/slate-react'
import { ELEMENT_TYPES } from 'cg/components/documents/editor/slate/types'
import { v4 as uuidv4 } from 'uuid'

const insertMath = (editor, path) => {
  const math = {
    type: ELEMENT_TYPES.math,
    formula: 'x^n + y^n = z^n',
    children: [{ uuid: uuidv4(), text: '', parent: { type: ELEMENT_TYPES.math } }]
  }

  Transforms.insertNodes(editor, math, { at: path })
}

export { insertMath }
